import BackButton from 'components/backButton'
import UpdateInventoryForm from 'components/inventory/updateInventoryForm'
import { useSafeBack } from 'hooks'
import { Helmet } from 'react-helmet'
import { PAGE_INVENTORY } from 'utils/constants'

const UpdateInventory = () => {
  const handleBack = useSafeBack(PAGE_INVENTORY.path)

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Update Master Data</title>
      </Helmet>

      <BackButton handleBack={handleBack} />

      <UpdateInventoryForm />
    </>
  )
}

export default UpdateInventory
